// extracted by mini-css-extract-plugin
export var container = "card-module--container--sY-HX";